import React from "react";
import dashboardJson from "../../../metadata.json";
// import { dataSource as section } from '../metadata.json';
import { Button } from "react-bootstrap";
import OX_Grid from "../Grid/OX_Grid";
import Notification from "../../Notification.tsx";
import Switch from "react-switch";
import DataSourceModal from "../Modals/DataSourceModal";
import "../../public/css/dataSource.scss";

class DataSource extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.args;
    this.state = {
      showModal: false,
      modalType: "",
      modalContent: {},
      checked: {},
    };
    this.refresh = React.createRef();
    this.notif = React.createRef();
    this.handleSwitch = this.handleSwitch.bind(this);
    this.checkedList = {};
  }

  componentDidMount() {
    //set switch respect to activated and deactivated datasource
    this.setState({ checked: this.checkedList });
  }

  handleSwitch(checked, event, id) {
    let toggleList = { ...this.state.checked };
    toggleList[id] = checked;
    this.setState({ checked: toggleList });
  }

  dataSourceOperation = (e, operation) => {
    this.setState({ showModal: true, modalContent: e, modalType: operation });
  };

  //functions for OX_Grid
  renderEmpty() {
    return [<React.Fragment key={1} />];
  }

  generateToggleButton = (dataItem, rule) => {
    var string = this.replaceParams(rule, dataItem);
    var showButton = eval(string);
    this.checkedList[dataItem.name] = showButton;
    showButton = true;
    return (
      <abbr
        className={this.checkedList[dataItem.name] ? "deactivateDash " : "activateDash "}
        title={this.checkedList[dataItem.name] ? "Deactivate" : "Activate"}
        key={Math.random()}
      >
        <Switch
          id={dataItem.name}
          onChange={(dataItem) => this.buttonAction({ name: "toggleActivate" }, dataItem)}
          checked={this.state.checked[dataItem.name]}
          onColor="#86d3ff"
          onHandleColor="#2693e6"
          handleDiameter={10}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={33}
          className="react-switch"
        />
      </abbr>
    );
  }

  renderListOperations = (config) => {
    return (
      <Button style={{ right: "10px", float: "right" }} onClick={() => this.buttonAction({ name: config.name })}>
        <i className='fa fa-plus' aria-hidden='true'></i> {config.name}
      </Button>
    );
  };

  replaceParams(route, params) {
    if (!params) {
      return route;
    }
    var regex = /\{\{.*?\}\}/g;
    let m;
    while ((m = regex.exec(route)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        route = route.replace(match, params[match.replace(/\{\{|\}\}/g, "")]);
      });
    }
    return route;
  }

  //calling relevant function with respective to action name
  buttonAction(action, item) {
    if (action.name !== undefined) {
      if (action.name === "toggleActivate" && item.isdeleted == "0") this.dataSourceOperation(item, "Delete");
      else if (action.name === "toggleActivate" && item.isdeleted == "1") this.dataSourceOperation(item, "Activate");
      else this.dataSourceOperation(item, action.name);
    }
  }

  render() {
    return (
      <div className='data-source'>
        <Button ref={this.create} style={{ right: "10px", float: "left", marginBottom: "10px" }} onClick={() => this.buttonAction({ name: "Create" })}>
          <i className='fa fa-plus' aria-hidden='true'></i> {"Create"}
        </Button>
        <Notification ref={this.notif} />
        <OX_Grid
          listOptions={{filterable: true}}
          ref={this.refresh}
          core={this.core}
          elementId={'[data-id="Analytics_Window"]'}
          dataSource={"analytics/datasource?show_deleted=true"}
          dataLoaderComponent={"DataLoader"}
          actions={[
            {
              name: "edit",
              // rule: "{{isdeleted}}==0",
              icon: "fa fa-pencil",
              classNames: "px-2",
              callback: (dataItem) => this.dataSourceOperation(dataItem, "Edit")
            },
          ]}
          actionButtonType={"inline"}
          filterable={true}
          sortable={true}
          style={{ float: "left" }}
          pageable={true}
          columnConfig={[
            {
              title: "Name",
              field: "name",
              type: "text",
              filterable: true
            },
          ]}
          gridToolbar={this.renderListOperations({
            name: "Create",
            rule: "true",
          })}
        />
        {this.state.showModal && <DataSourceModal osjsCore={this.core} modalType={this.state.modalType} show={this.state.showModal} onHide={() => this.setState({ showModal: false })} content={this.state.modalContent} handleChange={(e) => this.handleChange(e)} notification={this.notif} refreshGrid={this.refresh} />}
      </div>
    );
  }
}

export default DataSource;
